<template>
  <div class="main-header">
    <div class="logo-header" data-background-color="white">
      <router-link to="/campaigns" class="logo">
        <img src="../assets/img/logo_dark.png" height="60%" alt="navbar brand" class="navbar-brand">
      </router-link>
      <button class="navbar-toggler sidenav-toggler ml-auto" type="button" data-toggle="collapse" data-target="collapse" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon">
          <i class="icon-menu"></i>
        </span>
      </button>
      <button class="topbar-toggler more"><i class="icon-options-vertical"></i></button>
      <div class="nav-toggle">
        <button class="btn btn-toggle toggle-sidebar">
          <i class="icon-menu"></i>
        </button>
      </div>
    </div>
    <NavigationBar></NavigationBar>
  </div>
</template>
<script>
import NavigationBar from './NavigationBar.vue'

export default {
  name: 'Header',
  data: function () {
    return {}
  },
  components: {
    NavigationBar
  },
  mounted: function () {
    window['initSidebar']()
  }
}
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/Header.vue